import React from "react";
import PropTypes from "prop-types";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { NavLink } from "react-router-dom";
import cx from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Hidden from "@material-ui/core/Hidden";
import Collapse from "@material-ui/core/Collapse";

// core components
import HeaderLinks from "material-admin/components/Header/HeaderLinks";

import sidebarStyle from "material-admin/assets/jss/material-dashboard-pro-react/components/sidebarStyle";

import avatar from "material-admin/assets/img/faces/avatar.jpg";

var ps;

const testData = {
                "status": "ACTIVE",
                "id": "cjif5ixxh00s4097368roqpww",
                "name": "Newer Strategy",
                "bigGoals": [
                  {
                    "id": "cjif5ixxh00s50973mqsya3ds",
                    "index": 1,
                    responsible: {user: {id: "user-id"}},
                    "name": "Big Goal 1",
                    "stepGoals": [
                      {
                        "name": "Step Goal 1",
                        "index": 1,
                        "id": "cjif5ixxh00s60973nwmljl89",
                        "actionPlans": [
                          {
                            "name": "asdfasdfsdsadf34343434",
                            "index": 1,
                            "id": "cjif5ixxi00s70973vhw05bkc",
                          },
                          {
                            "name": "3",
                            "index": 2,
                            "id": "cjif5ixxi00s80973qetu2hc6"
                          },
                          {
                            "name": "Action Plan 3",
                            "index": 3,
                            "id": "cjif5ixxi00s90973mswwuh5s"
                          }
                        ]
                      },
                      {
                        "name": "Step Goal 2",
                        "index": 2,
                        "id": "cjif5ixxi00sa0973m6o2599l",
                        "actionPlans": [
                          {
                            "name": "Action Plan 1",
                            "index": 1,
                            "id": "cjif5ixxi00sb09737axgmu4s"
                          },
                          {
                            "name": "Action Plan 2",
                            "index": 2,
                            "id": "cjif5ixxi00sc0973ubj3bbum"
                          },
                          {
                            "name": "Action Plan 3",
                            "index": 3,
                            "id": "cjif5ixxi00sd0973fqqls3du"
                          }
                        ]
                      },
                      {
                        "name": "Step Goal 3",
                        "index": 3,
                        "id": "cjif5ixxj00se0973dzrjqnal",
                        "actionPlans": [
                          {
                            "name": "Action Plan 1",
                            "index": 1,
                            "id": "cjif5ixxj00sf0973g5o3dc8o"
                          },
                          {
                            "name": "Action Plan 2",
                            "index": 2,
                            "id": "cjif5ixxj00sg09733vrithys"
                          },
                          {
                            "name": "Action Plan 3",
                            "index": 3,
                            "id": "cjif5ixxj00sh09733bw6jaxs"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "id": "cjif5ixxj00si0973391j2d85",
                    "index": 2,
                    "name": "Big Goal 2",
                    "stepGoals": [
                      {
                        "name": "Step Goal 1",
                        "index": 1,
                        "id": "cjif5ixxj00sj0973wgvltgha",
                        "actionPlans": [
                          {
                            "name": "Action Plan 1",
                            "index": 1,
                            "id": "cjif5ixxj00sk0973n8rpxdc4"
                          },
                          {
                            "name": "Action Plan 2",
                            "index": 2,
                            "id": "cjif5ixxj00sl0973b0dv7gqr"
                          },
                          {
                            "name": "Action Plan 3",
                            "index": 3,
                            "id": "cjif5ixxj00sm09734xc718ag"
                          }
                        ]
                      },
                      {
                        "name": "Step Goal 2",
                        "index": 2,
                        "id": "cjif5ixxk00sn09735iwqieq7",
                        "actionPlans": [
                          {
                            "name": "Action Plan 1",
                            "index": 1,
                            "id": "cjif5ixxk00so0973zr7f08n5"
                          },
                          {
                            "name": "Action Plan 2",
                            "index": 2,
                            "id": "cjif5ixxk00sp0973sv8z3cd2"
                          },
                          {
                            "name": "Action Plan 3",
                            "index": 3,
                            "id": "cjif5ixxk00sq0973uecmcd76"
                          }
                        ]
                      },
                      {
                        "name": "Step Goal 3",
                        "index": 3,
                        "id": "cjif5ixxk00sr0973a2cwoxaf",
                        "actionPlans": [
                          {
                            "name": "Action Plan 1",
                            "index": 1,
                            "id": "cjif5ixxk00ss0973v7dy4eon"
                          },
                          {
                            "name": "Action Plan 2",
                            "index": 2,
                            "id": "cjif5ixxk00st0973buhm08kg"
                          },
                          {
                            "name": "Action Plan 3",
                            "index": 3,
                            "id": "cjif5ixxk00su097345gj71a9"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "id": "cjif5ixxk00sv0973gb15xe9p",
                    "index": 3,
                    "name": "Big Goal 3",
                    "stepGoals": [
                      {
                        "name": "Step Goal 1",
                        "index": 1,
                        "id": "cjif5ixxl00sw0973topsbl7f",
                        "actionPlans": [
                          {
                            "name": "Action Plan 1",
                            "index": 1,
                            "id": "cjif5ixxl00sx0973fvcpv3et"
                          },
                          {
                            "name": "Action Plan 2",
                            "index": 2,
                            "id": "cjif5ixxl00sy0973eoar7n68"
                          },
                          {
                            "name": "Action Plan 3",
                            "index": 3,
                            "id": "cjif5ixxl00sz09738kb5d0qv"
                          }
                        ]
                      },
                      {
                        "name": "Step Goal 2",
                        "index": 2,
                        "id": "cjif5ixxl00t009735iegro1t",
                        "actionPlans": [
                          {
                            "name": "Action Plan 1",
                            "index": 1,
                            "id": "cjif5ixxl00t10973fi19bvdy"
                          },
                          {
                            "name": "Action Plan 2",
                            "index": 2,
                            "id": "cjif5ixxl00t20973fh4qwhjk"
                          },
                          {
                            "name": "Action Plan 3",
                            "index": 3,
                            "id": "cjif5ixxl00t309732ly4ipb1"
                          }
                        ]
                      },
                      {
                        "name": "Step Goal 3",
                        "index": 3,
                        "id": "cjif5ixxl00t40973jji96t6e",
                        "actionPlans": [
                          {
                            "name": "Action Plan 1",
                            "index": 1,
                            "id": "cjif5ixxl00t509731ruqkf8a"
                          },
                          {
                            "name": "Action Plan 2",
                            "index": 2,
                            "id": "cjif5ixxm00t60973933c9qk1"
                          },
                          {
                            "name": "Action Plan 3",
                            "index": 3,
                            "id": "cjif5ixxm00t70973owe4thhu",
                            responsible: {user: {id: "user-id"}}
                          }
                        ]
                      }
                    ]
                  }
                ]
              }

class NestedTest extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,      
    }
  }
  componentDidUpdate(prevProps, prevState) {    
    if (!prevProps.siblingOpen && this.props.siblingOpen) {
      console.log("There was a change?")
      this.setState({isOpen: false})
    }
    
  }
  render() {
    const {classes} = this.props
    const itemText =
            classes.itemText +
            " " +
            cx({
              [classes.itemTextMini]:
              this.props.miniActive && this.state.miniActive,              
            });
    const children = this.props.bigGoals || this.props.stepGoals || this.props.actionPlans
    
    return (
      <List className={classes.list}>
        <ListItem key={this.props.id + " 3"} className={classes.item}>
          <ListItemText
             disableTypography={true}
             onClick={() => {
               this.setState({isOpen: !this.state.isOpen})
               if (this.props.notifyClick) {
                 this.props.notifyClick(this.props.index)
               }
               
              }}
            primary={this.props.name}
            className={itemText }>
            
          </ListItemText>
          {children ?
            <Collapse in={this.state.isOpen} >
                {children.map((c) => {
                  return <NestedTest
                              siblingOpen={this.props.siblingOpen || (this.state.activeChildIndex && (this.state.activeChildIndex != c.index))}
                              notifyClick={(i) => {
                                console.log("Child active?", i)
                                this.setState({activeChildIndex: i})
                              }}
                              key={c.id} {...c}
                              classes={classes} />
                  })}
              </Collapse>
              :
            <span/>}              
        </ListItem>
      </List>
    )
  }
}

// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
class SidebarWrapper extends React.Component {
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.sidebarWrapper, {
        suppressScrollX: true,
        suppressScrollY: false
      });
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  render() {
    const { classes, className, user, headerLinks, links } = this.props;    
    return (
      <div className={className} ref="sidebarWrapper">
        {user}
        {headerLinks}
        {links}
        <NestedTest
           {...testData}
           classes={classes}/>
      </div>
    );
  }
}

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      openComponents: this.activeRoute("/components"),
      openForms: this.activeRoute("/forms"),
      openTables: this.activeRoute("/tables"),
      openMaps: this.activeRoute("/maps"),
      openPages: this.activeRoute("-page"),
      miniActive: true
    };
    this.activeRoute.bind(this);
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? true : false;
  }
  openCollapse(collapse) {
    var st = {};
    st[collapse] = !this.state[collapse];
    this.setState(st);
  }
  render() {
    const {
      classes,
      color,
      logo,
      image,
      logoText,
      routes,
      bgColor,
      rtlActive
    } = this.props;
    
    const itemText =
            classes.itemText +
            " " +
            cx({
              [classes.itemTextMini]: this.props.miniActive && this.state.miniActive,
              [classes.itemTextMiniRTL]:
              rtlActive && this.props.miniActive && this.state.miniActive,
              [classes.itemTextRTL]: rtlActive
            });
    const collapseItemText =
            classes.collapseItemText +
            " " +
            cx({
              [classes.collapseItemTextMini]:
              this.props.miniActive && this.state.miniActive,
              [classes.collapseItemTextMiniRTL]:
              rtlActive && this.props.miniActive && this.state.miniActive,
              [classes.collapseItemTextRTL]: rtlActive
            });
    const userWrapperClass =
            classes.user +
            " " +
            cx({
              [classes.whiteAfter]: bgColor === "white"
            });
    const caret =
            classes.caret +
            " " +
            cx({
              [classes.caretRTL]: rtlActive
            });
    const collapseItemMini =
            classes.collapseItemMini +
            " " +
            cx({
              [classes.collapseItemMiniRTL]: rtlActive
            });
    const photo =
            classes.photo +
            " " +
            cx({
              [classes.photoRTL]: rtlActive
            });
    var user = (
      <div className={userWrapperClass}>
        <div className={photo}>
          <img src={avatar} className={classes.avatarImg} alt="..." />
        </div>
        <List className={classes.list}>
          <ListItem className={classes.item + " " + classes.userItem}>
            <NavLink
               to={"#"}
               className={classes.itemLink + " " + classes.userCollapseButton}
               onClick={() => this.openCollapse("openAvatar")}
              >
              <ListItemText
                 primary={rtlActive ? "تانيا أندرو" : "Tania Andrew"}
                 secondary={
                     <b
                          className={
                            caret +
                              " " +
                              classes.userCaret +
                              " " +
                              (this.state.openAvatar ? classes.caretActive : "")
                          }
                          />
                     }
                     disableTypography={true}
                     className={itemText + " " + classes.userItemText}
                     />
            </NavLink>
            <Collapse in={this.state.openAvatar} unmountOnExit>
              <List className={classes.list + " " + classes.collapseList}>
                <ListItem className={classes.collapseItem}>
                  <NavLink
                     to="#"
                     className={
                       classes.itemLink + " " + classes.userCollapseLinks
                     }
                     >
                    <span className={collapseItemMini}>
                      {rtlActive ? "مع" : "MP"}
                    </span>
                    <ListItemText
                       primary={rtlActive ? "ملفي" : "My Profile"}
                       disableTypography={true}
                       className={collapseItemText}
                       />
                  </NavLink>
                </ListItem>
                <ListItem className={classes.collapseItem}>
                  <NavLink
                     to="#"
                     className={
                       classes.itemLink + " " + classes.userCollapseLinks
                     }
                     >
                    <span className={collapseItemMini}>
                      {rtlActive ? "هوع" : "EP"}
                    </span>
                    <ListItemText
                       primary={
                         rtlActive ? "تعديل الملف الشخصي" : "Edit Profile"
                       }
                       disableTypography={true}
                       className={collapseItemText}
                       />
                  </NavLink>
                </ListItem>
                <ListItem className={classes.collapseItem}>
                  <NavLink
                     to="#"
                     className={
                       classes.itemLink + " " + classes.userCollapseLinks
                     }
                     >
                    <span className={collapseItemMini}>
                      {rtlActive ? "و" : "S"}
                    </span>
                    <ListItemText
                       primary={rtlActive ? "إعدادات" : "Settings"}
                       disableTypography={true}
                       className={collapseItemText}
                       />
                  </NavLink>
                </ListItem>
              </List>
            </Collapse>
          </ListItem>
        </List>
      </div>
    );
    var links = (
      <List className={classes.list}>
        {routes.map((prop, key) => {
          if (prop.redirect) {
            return null;
          }
          if (prop.collapse) {
            const navLinkClasses =
                    classes.itemLink +
                    " " +
                    cx({
                      [" " + classes.collapseActive]: this.activeRoute(prop.path)
                    });
            const itemText =
                    classes.itemText +
                    " " +
                    cx({
                      [classes.itemTextMini]:
                      this.props.miniActive && this.state.miniActive,
                      [classes.itemTextMiniRTL]:
                      rtlActive && this.props.miniActive && this.state.miniActive,
                      [classes.itemTextRTL]: rtlActive
                    });
            const collapseItemText =
                    classes.collapseItemText +
                    " " +
                    cx({
                      [classes.collapseItemTextMini]:
                      this.props.miniActive && this.state.miniActive,
                      [classes.collapseItemTextMiniRTL]:
                      rtlActive && this.props.miniActive && this.state.miniActive,
                      [classes.collapseItemTextRTL]: rtlActive
                    });
            const itemIcon =
                    classes.itemIcon +
                    " " +
                    cx({
                      [classes.itemIconRTL]: rtlActive
                    });
            const caret =
                    classes.caret +
                    " " +
                    cx({
                      [classes.caretRTL]: rtlActive
                    });
            return (
              <ListItem key={key} className={classes.item}>
                <NavLink
                   to={"#"}
                   className={navLinkClasses}
                   onClick={() => this.openCollapse(prop.state)}
                  >
                  <ListItemIcon className={itemIcon}>
                    <prop.icon />
                  </ListItemIcon>
                  <ListItemText
                     primary={prop.name}
                     secondary={
                         <b
                              className={
                                caret +
                                  " " +
                                  (this.state[prop.state] ? classes.caretActive : "")
                              }
                              />
                         }
                         disableTypography={true}
                         className={itemText}
                         />
                </NavLink>
                <Collapse in={this.state[prop.state]} unmountOnExit>
                  <List className={classes.list + " " + classes.collapseList}>
                    {prop.views.map((prop, key) => {
                      if (prop.redirect) {
                        return null;
                      }
                      const navLinkClasses =
                              classes.collapseItemLink +
                              " " +
                              cx({
                                [" " + classes[color]]: this.activeRoute(prop.path)
                              });
                      const collapseItemMini =
                              classes.collapseItemMini +
                              " " +
                              cx({
                                [classes.collapseItemMiniRTL]: rtlActive
                              });
                      return (
                        <ListItem key={key} className={classes.collapseItem}>
                          <NavLink to={prop.path} className={navLinkClasses}>
                            <span className={collapseItemMini}>
                              {prop.mini}
                            </span>
                            <ListItemText
                               primary={prop.name}
                               disableTypography={true}
                               className={collapseItemText}
                               />
                          </NavLink>
                        </ListItem>
                      );
                    })}
              </List>
                </Collapse>
                </ListItem>
            );
          }
          const navLinkClasses =
                  classes.itemLink +
                  " " +
                  cx({
                    [" " + classes[color]]: this.activeRoute(prop.path)
                  });
          const itemText =
                  classes.itemText +
                  " " +
                  cx({
                    [classes.itemTextMini]:
                    this.props.miniActive && this.state.miniActive,
                    [classes.itemTextMiniRTL]:
                    rtlActive && this.props.miniActive && this.state.miniActive,
                    [classes.itemTextRTL]: rtlActive
                  });
          const itemIcon =
                  classes.itemIcon +
                  " " +
                  cx({
                    [classes.itemIconRTL]: rtlActive
                  });
          return (
            <ListItem key={key} className={classes.item}>
              <NavLink to={prop.path} className={navLinkClasses}>
                <ListItemIcon className={itemIcon}>
                  <prop.icon />
                </ListItemIcon>
                <ListItemText
                   primary={prop.name}
                   disableTypography={true}
                   className={itemText}
                   />
              </NavLink>
            </ListItem>
          );
        })}
      </List>
    );

    const logoNormal =
            classes.logoNormal +
            " " +
            cx({
              [classes.logoNormalSidebarMini]:
              this.props.miniActive && this.state.miniActive,
              [classes.logoNormalSidebarMiniRTL]:
              rtlActive && this.props.miniActive && this.state.miniActive,
              [classes.logoNormalRTL]: rtlActive
            });
    const logoMini =
            classes.logoMini +
            " " +
            cx({
              [classes.logoMiniRTL]: rtlActive
            });
    const logoClasses =
            classes.logo +
            " " +
            cx({
              [classes.whiteAfter]: bgColor === "white"
            });
    var brand = (
      <div className={logoClasses}>
        <a href="https://www.creative-tim.com" className={logoMini}>
          <img src={logo} alt="logo" className={classes.img} />
        </a>
        <a href="https://www.creative-tim.com" className={logoNormal}>
          {logoText}
        </a>
      </div>
    );
    const drawerPaper =
            classes.drawerPaper +
            " " +
            cx({
              [classes.drawerPaperMini]:
              this.props.miniActive && this.state.miniActive,
              [classes.drawerPaperRTL]: rtlActive
            });
    const sidebarWrapper =
            classes.sidebarWrapper +
            " " +
            cx({
              [classes.drawerPaperMini]:
              this.props.miniActive && this.state.miniActive,
              [classes.sidebarWrapperWithPerfectScrollbar]:
              navigator.platform.indexOf("Win") > -1
            });
    return (
      <div ref="mainPanel">
        <Hidden mdUp>
          <Drawer
             variant="temporary"
             anchor={rtlActive ? "left" : "right"}
             open={this.props.open}
             classes={{
               paper: drawerPaper + " " + classes[bgColor + "Background"]
             }}
             onClose={this.props.handleDrawerToggle}
             ModalProps={{
               keepMounted: true // Better open performance on mobile.
             }}
             >
            {brand}
            <SidebarWrapper
               classes={classes}
               className={sidebarWrapper}
               user={user}
               headerLinks={<HeaderLinks rtlActive={rtlActive} />}
               links={links}
               />
            {image !== undefined ? (
              <div
                 className={classes.background}
                 style={{ backgroundImage: "url(" + image + ")" }}
                 />
            ) : null}
      </Drawer>
        </Hidden>
        <Hidden smDown>
        <Drawer
      onMouseOver={() => this.setState({ miniActive: false })}
      onMouseOut={() => this.setState({ miniActive: true })}
      anchor={rtlActive ? "right" : "left"}
      variant="permanent"
      open
      classes={{
        paper: drawerPaper + " " + classes[bgColor + "Background"]
      }}
        >
        {brand}
        <SidebarWrapper
      classes={classes}
      className={sidebarWrapper}
      user={user}
      links={links}
        />
        {image !== undefined ? (
          <div
             className={classes.background}
             style={{ backgroundImage: "url(" + image + ")" }}
             />
        ) : null}
      </Drawer>
        </Hidden>
        </div>
    );
  }
}

Sidebar.defaultProps = {
  bgColor: "blue"
};

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  bgColor: PropTypes.oneOf(["white", "black", "blue"]),
  rtlActive: PropTypes.bool,
  color: PropTypes.oneOf([
    "white",
    "red",
    "orange",
    "green",
    "blue",
    "purple",
    "rose"
  ]),
  logo: PropTypes.string,
  logoText: PropTypes.string,
  image: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object)
};

export default withStyles(sidebarStyle)(Sidebar);
